/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from "react";
import DefaultBook from "../Images/defaultBook.png";
import KalyansServices from "../Services/Kalyan";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Styles/BookDetail.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import Favfill from "../assets/img/favadd.svg";
import Favempty from "../assets/img/fav.svg";
import { BookContentType } from "./Epub";
import { userId } from "../Contexts/LocaleContext";
import { LogInModel } from "./LoginModel";
import leftArrow from "../assets/img/leftArrow1.png";
import rightArrow from "../assets/img/rightArrow1.png"
import closeicon from "../Images/close-round-border.svg"
import EpubServices from "../Services/Epub";
import { Breadcrumbs } from "./E-BooksComponent";
import bookmarkIcon from "../Images/Bookmark.svg"
import Loader from "./Loader";
import BookCoverPopup from "../Components/BookCoverPopup";
import { getMonthNameFromNumber } from "../Components/MonthUtils";
import { listToTree } from "../utils/tocUtils";
import KalyanSeo from "../Components/kalyanSeo";

const PrevArrow = ({ className, style, onClick }: any) => (
  <div className={className} style={style} onClick={onClick}>
    <img src={leftArrow} alt="Previous" height="40px" />
  </div>
);

const NextArrow = ({ className, style, onClick }: any) => (
  <div className={className} style={style} onClick={onClick}>
    <img src={rightArrow} alt="Next" height="40px" />
  </div>
);

const KalyanDetailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [kalyanDetail, setKalyanDetail] = useState<any>(undefined);
  const [refresh, setRefresh] = useState(false);
  const [kalyanId, setKalyanId] = useState("");
  const [relateds, setRelatedKalyans] = useState<any[] | undefined>(undefined);

  const location = useLocation();
  const [isLiked, setIsLiked] = useState<boolean>(false);
  const [showCoverPopup, setShowCoverPopup] = useState(false);
  const state = location.state as {
    kalyanId: string,
    kalyanSlug: string,
    bookName: string,
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };

  const [logIn, setLogIn] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  const closeModal = () => {
    setLogIn(false);
  };

  const UserIdentity = localStorage.getItem("UserId") as any;

  const [toggleFav, setToggleFav] = useState<boolean>(false);

  const [bookMark, setBookMark] = useState<boolean>(false)
  const [bookMarkData, setBookMarkData] = useState<any[] | undefined | any>(undefined);
  const [description, setDescription] = useState({ __html: "" });
  const [activeTab, setActiveTab] = useState<'related' | 'description' | 'toc'>('related');
  const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());
  const [lastPos, setLastPos] = useState<any>(null);
  const [lastFontSize, setLastFontSize] = useState<number>(100);
  const [toc, setToc] = useState<any[]>([]);
  const [progress, setProgress] = useState<number>(0);
  const [navOrder, setNavOrder] = useState<number>(0);

  const navigationTree = useMemo(() => listToTree(toc), [toc]);
  const flatToc = useMemo(() => toc, [toc]);

  const notificationRef = useRef<any>(null);

  const showNotification = (message: any) => {
    notificationRef.current.innerText = message;
    notificationRef.current.style.display = 'block';

    setTimeout(() => {
      notificationRef.current.style.display = 'none';
    }, 3000); // Hide the notification after 2 seconds
  };

  const [loginState, setLoginState] = useState<boolean>(false);

  const toggleNode = (nodeId: string) => {
    setExpandedNodes((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) {
        next.delete(nodeId);
      } else {
        next.add(nodeId);
      }
      return next;
    });
  };

  const renderTocNode = (node: any, index: number, flatIndex?: number) => {
    const isExpanded = expandedNodes.has(node.navId || `node-${index}`);
    const hasChildren = node.children && node.children.length > 0;

    const totalChapters = flatToc.length;
    const readCount = Math.floor((totalChapters * progress) / 100);
    const currentFlatIndex =
      flatIndex !== undefined
        ? flatIndex
        : flatToc.findIndex((n: any) => n.navId === node.navId);
    const isRead = currentFlatIndex !== -1 && currentFlatIndex < readCount;

    return (
      <li key={node.navId || index} className="toc-node">
        <div
          className={`node ${isRead ? "read" : "unread"}`}
          onClick={() => hasChildren && toggleNode(node.navId || `node-${index}`)}
          style={{ cursor: hasChildren ? "pointer" : "default" }}
        >
          {hasChildren ? (
            <span className="node-toggle">{isExpanded ? "-" : "+"}</span>
          ) : (
            <span className="node-bullet">•</span>
          )}
          <div
            className="node-label"
            onClick={(e) => {
              if (!hasChildren) {
                e.stopPropagation();
                navigate(`/reader/kalyan/` + kalyanDetail?.slug, {
                  state: {
                    kalyanDetailId: kalyanDetail?.id,
                    bookName: kalyanDetail?.name,
                    slug: kalyanDetail?.slug,
                    location:
                      node.srcFile + (node.srcAnchor ? `#${node.srcAnchor}` : "") ||
                      node.href,
                    tocNode: node,
                    type: BookContentType.kalyan,
                  },
                });
              }
            }}
            style={{ cursor: "pointer" }}
          >
           <h3 style={{fontSize:"22px",fontWeight:400,fontFamily:"ChanakyaUni, NalandaTim, Tunga"}}> {node.label || node.title}</h3>
          </div>
        </div>
        {hasChildren && (
          <ul className={`children ${isExpanded ? "expanded" : ""}`}>
            {node.children.map((child: any, cIdx: number) => {
              const childFlatIndex = flatToc.findIndex((n: any) => n.navId === child.navId);
              return renderTocNode(child, `${index}-${cIdx}` as any, childFlatIndex);
            })}
          </ul>
        )}
      </li>
    );
  };

  function createMarkup() {
    return { __html: description.__html };
  }

  const hasVisibleDescription = useMemo(() => {
    const html = description?.__html || "";
    const text = html
      .replace(/&nbsp;/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
    return text.length > 0;
  }, [description]);

  const hasToc = toc.length > 0;
  const hasRelateds = useMemo(() => !!(relateds && relateds.length > 0), [relateds]);

  const indicatorTranslate = useMemo(() => {
    const tabs = [];
    if (hasRelateds) tabs.push('related');
    if (hasVisibleDescription) tabs.push('description');
    if (hasToc) tabs.push('toc');

    const tabIndex = tabs.indexOf(activeTab);
    return `${tabIndex * 160}px`;
  }, [hasRelateds, hasVisibleDescription, hasToc, activeTab]);

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
    navigate(`/reader/kalyan/` + kalyanDetail.slug, {
      state: {
        kalyanDetailId: kalyanId,
        bookName: state?.bookName,
        slug: state?.kalyanSlug,
        type: BookContentType.kalyan,
      },
    });
  };

  const notify = () => {
    if (UserIdentity) {
      showNotification(!isLiked
        ?
        localStorage.getItem("lan") === "hindi"
          ? "पत्रिका को सफलतापूर्वक मेरी पसंद में जोड़ा गया है।"
          : "Magazine has been successfully added to the favourites"
        : localStorage.getItem("lan") === "hindi"
          ? "पत्रिका मेरी पसंद से हटा दी गई है।"
          : "Magazine has been removed from favourites"
      )
    }
  };

  const toggleLike = () => {
    !isLiked
      ? KalyansServices.addKalyanFavourite(kalyanId).then((res) => {
        res.status && setIsLiked(true);
      })
      : KalyansServices.removeKalyanFavourite(kalyanId).then((res) => {
        res.status && setIsLiked(false);
      });
    setToggleFav((x) => !x);
  };

  const monthName = getMonthNameFromNumber(kalyanDetail?.months);

  useEffect(() => {
    if (location.state) {
      setKalyanId(state?.kalyanId);
    }
  }, [location]);

  useEffect(() => {
    if (kalyanId) {
      setRefresh(false);
      const fetchData = async () => {
        try {
          // Prefer any prefetched detail passed via navigation state, fall back to local state
          const prefetched = kalyanDetail;

          const [kalyanRes, navRes] = await Promise.all([
            prefetched ? Promise.resolve({ status: true, result: prefetched }) : KalyansServices.getKalyanDetail(kalyanId),
            KalyansServices.getNavigationDetails(kalyanId),
          ]);

          if (prefetched) {
            console.log("KalyanDetailPage: using pre-fetched kalyanDetail from navigation state, skipping API call.");
          } else {
            console.log("API Responses - Kalyan:", kalyanRes, "Nav:", navRes);
          }

          if (kalyanRes?.status) {
            setDescription({ __html: kalyanRes.result?.description || "" });
            setKalyanDetail(kalyanRes.result);
            setIsLiked(kalyanRes.result?.isFavourite);
          }

          // const navRes = await KalyansServices.getNavigationDetails(kalyanId);
          if (navRes?.status) {
            const navigationTree = navRes.result?.navigationTree || [];
            setToc(navigationTree);

            if (navRes.result?.lastPosition) {
              setLastPos(navRes.result.lastPosition);
            }

            const rawFont = navRes.result?.bookFontSize;
            const parsedFont = parseFloat(rawFont);
            setLastFontSize(
              rawFont !== null &&
                rawFont !== undefined &&
                rawFont !== "" &&
                rawFont !== "null" &&
                !isNaN(parsedFont)
                ? parsedFont
                : 100
            );

            if (navRes.result?.navOrder) {
              const totalChapters = navigationTree.length;
              setProgress(totalChapters > 0 ? (navRes.result.navOrder / totalChapters) * 100 : 0);
            } else {
              setProgress(0);
            }
            setNavOrder(navRes.result?.navOrder || 0);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchData();
    }
  }, [refresh, i18n.language, kalyanId, kalyanDetail]);

  useEffect(() => {
    setRefresh(false);
    if (kalyanId) {
      KalyansServices.getRelatedKalyans(kalyanId).then((res) => {
        if (res?.status) {
          setRelatedKalyans(res.result);
        }
      });
    }
  }, [refresh, i18n.language, kalyanId]);

  useEffect(() => {
    if (kalyanId) {
      EpubServices.getbookmark(
        "kalyanbookmarks",
        kalyanId
      ).then((res: any) => {
        if (res.status) {
          setBookMarkData(res?.result)
        }
      });
    }
  }, [refresh, i18n.language, userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!hasVisibleDescription && activeTab === "description") {
      if (hasToc) setActiveTab("toc");
    }
  }, [hasVisibleDescription, activeTab, hasToc]);

  useEffect(() => {
    if (!hasToc && activeTab === "toc") {
      if (hasVisibleDescription) setActiveTab("description");
    }
  }, [hasToc, activeTab, hasVisibleDescription]);

  return (
    <>

      {kalyanDetail?.slug ? (
        <>
          <KalyanSeo
            kalyan={kalyanDetail}
            canonicalPath={`/magazines/kalyan/${kalyanDetail?.slug}`}
          />
        </>
      ) : null}

      <div
        className="newcontainer"
        style={{
          backgroundColor: "#FFF6E1",
          padding: "1px 0px 4% 0",
          marginTop: 0,
        }}
      >
        <Breadcrumbs
          mainsubBreadCrumb={t("Kalyan_tr")}
          subBreadCrumb={t("Home_tr")}
          navigatemainsubBreadCrumb={() => {
            navigate(`/`);
          }}
          subBreadCrumbTwo={t("magazine_tr")}
          navigatesubBreadCrumb={() => {
            navigate(`/magazines`);
          }}
          subBreadCrumbThree={t("Kalyan_tr")}
          navigatethreeBreadCrumb={() => {
            navigate(`/magazines/kalyan`);
          }}
          subBreadCrumbFour={kalyanDetail?.name}
        />
        
        <div className="container">
          <div className="row">
            <div>
              {kalyanDetail ? (
                <div
                  className="containers card-gst"
                  style={{
                    width: "100%",
                    marginTop: "25px",
                    backgroundColor: "#FFFAF0",
                    boxShadow: "0px 0px 10px 0px #dcd1b8",
                  }}
                >
                  <div className="mat-card row" key={`book-${kalyanDetail.id}`}>
                    <div style={{ padding: "0px 0px 0 0px", margin: "0 0 0 0" }}>
                      <div className="single-product col-lg-3">
                        <div
                          style={{
                            border: "1px solid #eadfc8",
                            padding: "30px",
                            background: "#fff",
                            borderRadius: "5px",
                            textAlign: "center",
                            width: "125%",
                          }}
                        >
                          <img
                            src={kalyanDetail.kalyanThumbPath}
                            onError={(e) => {
                              e.currentTarget.src = DefaultBook;
                            }}
                            onClick={() => setShowCoverPopup(true)}
                            alt={kalyanDetail.name}
                            title={kalyanDetail.name}
                            className="bkdetailimg"
                            style={{ cursor: "pointer" }}
                            width="256"
                            height="365"
                          />
                        </div>
                      </div>

                      <div className="single-product-author col-lg-8">
                        <div className="single-book-heading">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <h1
                              style={{
                                fontFamily: "ChanakyaUni",
                                fontSize: "40px",
                                color: "#472d1e",
                                marginTop: "7px",
                              }}
                            >
                              {kalyanDetail.name}
                            </h1>
                            <label
                              onClick={() => {
                                if (!userId) setLogIn(true);
                              }}
                              style={{ display: "flex", margin: 0 }}
                            >
                              <label style={{ display: bookMarkData?.length > 0 ? "block" : "none", marginRight: "10px" }}>
                                <div className="bkmarkicon"
                                  onClick={() => {
                                    setBookMark(bookMark === true ? false : true)
                                  }}>
                                  <div>
                                    <img src={bookmarkIcon} style={{ width: "45px", height: "45px" }} alt="bookmaarkicon" />
                                  </div>
                                  <div>
                                    {bookMark && userId && (
                                      <div className="bkmarkicon-style">
                                        <div style={{
                                          display: "flex",
                                          backgroundColor: "#ff6427"
                                        }}>
                                          <p
                                            style={{
                                              color: "#fff",
                                              fontStyle: "normal",
                                              lineHeight: "normal",
                                              borderBottom: "none",
                                              padding: "0 0 0 10%",
                                              margin: 0,
                                            }}>{t("bk_mark_tr")}</p>
                                          <img src={closeicon} style={{ width: "20px", height: "20px", margin: "4px 0 0 10px", cursor: "pointer" }} onClick={() => setBookMark(false)} alt="" />
                                        </div>
                                        <ol style={{ paddingLeft: "20px", fontSize: "20px" }}>
                                          {bookMarkData && bookMarkData?.map((item: any, index: number) => (
                                            <li onClick={() => {
                                              navigate(`/reader/kalyan/` + kalyanDetail.slug, {
                                                state: {
                                                  kalyanDetailId: kalyanDetail.id,
                                                  bookName: kalyanDetail.name,
                                                  chapterName: item?.name,
                                                  slug: kalyanDetail.slug,
                                                  location: item?.cfi,
                                                  type: BookContentType.kalyan,
                                                },
                                              });
                                            }}>
                                              <p style={{ borderBottom: "none", padding: 0, margin: "0 0 0 5px", color: "#000", cursor: "pointer" }}>{item?.name}</p></li>
                                          ))}
                                        </ol>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </label>

                              <label
                                onClick={() => {
                                  toggleLike();
                                  notify();
                                }}
                              >
                                <img
                                  src={isLiked ? Favfill : Favempty}
                                  alt="Favicon"
                                  style={{ width: "45px", cursor: "pointer" }}
                                />
                              </label>
                            </label>
                          </div>
                        </div>
                        {kalyanDetail.author ? (
                          <div>
                            <p>
                              <label>{t("Authors_tr")} </label>
                              {kalyanDetail.author}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {kalyanDetail.kalyanLanguage ? (
                          <div>
                            <p>
                                 <h2
                              style={{
                                display: "inline",
                                marginRight: "85px",
                                fontSize: "23px",
                                color: 'black'
                              }}
                            >
                              {t("Language_tr")}
                            </h2>
                                <h2
                              style={{
                                display: "inline",
                                marginRight: "85px",
                                fontSize: "23px",
                                color: '#ff731f'
                              }}
                            >
                                {kalyanDetail.kalyanLanguage}
                            </h2>
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="bookdecription">
                          <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px" }}>
                            <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", margin: '0 40% 0 0', paddingBottom: 0 }}>{t("Year_tr")}</label>
                            <label style={{ fontSize: "23px", color: "#ff731f" }}>{kalyanDetail?.years}</label>
                          </div>
                          <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderLeft: 0, borderRight: 0 }}>
                            <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", margin: '0 40% 0 0' }}>{t("Month_tr")}</label>
                            <label style={{ fontSize: "23px", color: "#ff731f" }}>{monthName}</label>
                          </div>
                          <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderTopRightRadius: "5px", borderBottomRightRadius: "5px" }}>
                            <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", margin: '0 40% 0 0' }}>{t("Number_tr")}</label>
                            <label style={{ fontSize: "23px", color: "#ff731f" }}>{kalyanDetail?.editionNo}</label>
                          </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                          <div ref={notificationRef} style={{ color: "#ff3d28", fontSize: '20px', marginBottom: "10px" }} className="notification-bar"></div>
                          <div className="actions">
                            {navOrder > 0 && (
                              <div className="book-progress">
                                <div className="book-progress__label">{Math.round(progress)} %</div>
                                <div className="book-progress__track">
                                  <div className="book-progress__value" style={{ width: `${progress}%` }}></div>
                                </div>
                              </div>
                            )}
                            <div className="buttons">
                              {navOrder === 0 ? (
                                <button
                                  className="btn-book-action"
                                  onClick={() => {
                                    if (UserIdentity) {
                                      navigate(`/reader/kalyan/` + kalyanDetail.slug, {
                                        state: {
                                          kalyanDetailId: kalyanDetail.id,
                                          bookName: kalyanDetail.name,
                                          slug: kalyanDetail.slug,
                                          type: BookContentType.kalyan,
                                        },
                                      });
                                    } else {
                                      setLogIn(true);
                                    }
                                  }}
                                >
                                  {t("read_magazine_tr")}
                                </button>
                              ) : (
                                <>
                                  <button
                                    className="btn-book-action"
                                    onClick={() => {
                                      if (UserIdentity) {
                                        navigate(`/reader/kalyan/` + kalyanDetail.slug, {
                                          state: {
                                            kalyanDetailId: kalyanDetail.id,
                                            bookName: kalyanDetail.name,
                                            slug: kalyanDetail.slug,
                                            type: BookContentType.kalyan,
                                          },
                                        });
                                      } else {
                                        setLogIn(true);
                                      }
                                    }}
                                  >
                                    {t("Read_From_Start_tr")}
                                  </button>
                                  <button
                                    className="btn-book-action"
                                    onClick={() => {
                                      navigate(`/reader/kalyan/` + kalyanDetail.slug, {
                                        state: {
                                          kalyanDetailId: kalyanDetail.id,
                                          bookName: kalyanDetail.name,
                                          slug: kalyanDetail.slug,
                                          location: lastPos,
                                          type: BookContentType.kalyan,
                                          fontsize: lastFontSize,
                                        },
                                      });
                                    }}
                                  >
                                    {t("Continue_Reading_tr")}
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ margin: "0 05px 5% 05px" }}>
                    <div className="tabs-container">
                      <div className="tabs-line">
                        <div className="tabs" role="tablist">
                          {hasRelateds && (
                            <button
                              className="tab"
                              aria-selected={activeTab === 'related'}
                              onClick={() => setActiveTab('related')}
                            >

                              <h2 style={{ fontSize: "18px", fontWeight: 700 }} >{t("Related_Kalyan_tr")}</h2>

                            </button>
                          )}
                          {hasVisibleDescription && (
                            <button
                              className="tab"
                              aria-selected={activeTab === "description"}
                              onClick={() => setActiveTab("description")}
                            >
                              {t("Description_tr")}
                            </button>
                          )}
                          {hasToc && (
                            <button
                              className="tab"
                              aria-selected={activeTab === "toc"}
                              onClick={() => setActiveTab("toc")}
                            >

                             <h2 style={{ fontSize: "20px", fontWeight: 700, }} >{t("Table_of_Contents_tr")}</h2>
                           </button>
                          )}
                        </div>
                        <div
                          className="tab-indicator"
                          style={{
                            transform: `translateX(${indicatorTranslate})`,
                            width: "140px",
                          }}
                        ></div>
                      </div>

                      <div className="tab-panels">
                        {hasRelateds && activeTab === 'related' && (
                          <div className="panel active">
                            <div style={{ margin: "20px" }}>
                              <div className="clsslide row">
                                <div>
                                  <div style={{ paddingBottom: "20px", width: "97%", position: "relative", left: "18px" }}>
                                    <Slider {...settings} infinite={relateds && relateds.length > 5}>
                                      {relateds && relateds.map((related: any) => (
                                        <div
                                          className="slider-books sidebarmargin"
                                          key={`related-${related.id}`}
                                          onClick={() => {
                                            navigate(`/magazines/kalyan/${related.slug}`, {
                                              state: {
                                                kalyanId: related.id,
                                                kalyanSlug: related.slug
                                              }
                                            });
                                          }}
                                        >
                                          <div>
                                            <img
                                              src={related.kalyanThumbPath || DefaultBook}
                                              onError={(e: any) => e.currentTarget.src = DefaultBook}
                                              className="imgcenter"
                                              style={{ cursor: "pointer", borderRadius: 0 }}
                                              alt={related.name}
                                              title={related.name}
                                              width="150"
                                              height="212"
                                            />
                                            <h3 style={{ fontFamily: "ChanakyaUni" ,fontSize:"18px",paddingTop:12}}>{related.name}</h3>
                                          </div>
                                        </div>
                                      ))}
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {hasVisibleDescription && (
                          <div className={`panel ${activeTab === "description" ? "active" : ""}`}>
                            <div dangerouslySetInnerHTML={createMarkup()}></div>
                          </div>
                        )}

                        {hasToc && (
                          <div className={`panel ${activeTab === "toc" ? "active" : ""}`}>
                            <ul className="toc">
                              {navigationTree.map((node: any, idx: number) => renderTocNode(node, idx))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Related slider moved to tabs */}
                </div>
              ) : (
                <div className="ebooks-category resultnotfound">
                  {loading && <Loader loading={loading} />}
                  {t("result_not_found_tr")}
                </div>
              )}
            </div>
          </div>
          <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
          {kalyanDetail && (
            <BookCoverPopup
              show={showCoverPopup}
              onClose={() => setShowCoverPopup(false)}
              imagePath={kalyanDetail.kalyanThumbPath}
              bookName={kalyanDetail.name}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default KalyanDetailPage;
